import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "@firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBR2YYzzxEtl_Hd3flIXE_PmG2eyB39Wt4",
  authDomain: "project-family-court.firebaseapp.com",
  databaseURL: "https://project-family-court.firebaseio.com",
  projectId: "project-family-court",
  storageBucket: "project-family-court.appspot.com",
  messagingSenderId: "296420125083",
  appId: "1:296420125083:web:83c9801ec7b7c51bebd93e",
  measurementId: "G-HH59W2B4K4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Utility function to log events
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  logEvent(analytics, eventName, eventParams);
};

export { analytics };
